import type { BrandAsset } from "../types";

export const brandAssets: BrandAsset[] = [
  {
    id: "main-logo",
    title: "Основной красный логотип Social",
    description: "Официальная красная RGB-версия логотипа для светлого фона.",
    category: "logo",
    fileType: "svg",
    url: "/downloads/social-logo-red.svg",
    previewUrl: "/assets/social-logo-red.svg",
    previewTone: "light",
    version: "RGB color red",
    status: "current",
    usage: "Использовать на белом или другом согласованном светлом фоне. Не изменять форму, цвет или пропорции.",
    language: "multi",
    updatedAt: "2026-07-29",
    fileSize: "3 КБ",
    tags: ["логотип", "social", "основной", "svg", "красный", "rgb"],
  },
  {
    id: "white-logo",
    title: "Белая версия логотипа",
    description: "Актуальный белый SVG для контрастного фона.",
    category: "logo",
    fileType: "svg",
    url: "/downloads/social-logo-white.svg",
    previewUrl: "/assets/social-logo-white.svg",
    previewTone: "brand",
    version: "RGB color white",
    status: "current",
    usage: "Для Pulse Red, Trust Blue, Expertise и фотографий с достаточным контрастом.",
    language: "multi",
    updatedAt: "2026-07-29",
    fileSize: "3 КБ",
    tags: ["логотип", "белый", "тёмный фон", "svg"],
  },
  {
    id: "dark-logo",
    title: "Тёмная версия логотипа",
    description: "Официальная тёмная монохромная RGB-версия для светлого фона.",
    category: "logo",
    fileType: "svg",
    url: "/downloads/social-logo-dark.svg",
    previewUrl: "/assets/social-logo-dark.svg",
    previewTone: "light",
    version: "RGB monochrome dark",
    status: "current",
    usage: "Использовать на белом или другом согласованном светлом фоне.",
    language: "multi",
    updatedAt: "2026-07-29",
    fileSize: "3 КБ",
    tags: ["логотип", "тёмный", "светлый фон", "svg", "rgb", "монохромный"],
  },
  {
    id: "brand-guidelines",
    title: "Social Brand Guidelines",
    description: "Полное руководство по логотипу, цветам, типографике, сеткам, иконкам и фотографии.",
    category: "brandbook",
    fileType: "pdf",
    url: "/files/social-brand-guidelines.pdf",
    version: "1.0",
    status: "current",
    usage: "Только для внутреннего использования. Любые внешние материалы должны пройти проверку Marketing Department.",
    language: "multi",
    updatedAt: "2026-07-28",
    fileSize: "6,2 МБ",
    tags: ["брендбук", "гайдлайн", "цвета", "логотип", "типографика", "brand guidelines"],
  },
  {
    id: "social-ppt-en",
    title: "Social PPT — Project Overview",
    description: "Презентация с описанием проекта, инфраструктуры, плановой мощности и медицинских направлений.",
    category: "presentation",
    fileType: "pdf",
    url: "/files/social-ppt-project-overview-en.pdf",
    version: "Апрель 2026",
    status: "current",
    usage: "Источник фактов. Перед внешним использованием проверять статус конкретной цифры в базе.",
    language: "en",
    updatedAt: "2026-07-15",
    fileSize: "2,4 МБ",
    tags: ["презентация", "project overview", "english", "факты", "инфраструктура"],
  },
  {
    id: "social-ppt-ru",
    title: "Презентация проекта на русском языке",
    description: "Русскоязычная версия ещё не добавлена.",
    category: "presentation",
    fileType: "pptx",
    url: "#replace-with-real-file-url",
    version: "Требуется",
    status: "needs-review",
    usage: "Перед использованием заменить реальным согласованным файлом.",
    language: "ru",
    updatedAt: "2026-07-15",
    tags: ["презентация", "русский", "pptx"],
    placeholder: true,
  },
  {
    id: "sps-photos",
    title: "Фотографии первого SPS",
    description: "Фотографии с первой симуляции SPS в общей папке Google Drive.",
    category: "photo",
    fileType: "folder",
    url: "https://drive.google.com/drive/folders/15beYJwDF5dOjMJBDV3u__3-21a3Hum5X?usp=sharing",
    status: "current",
    usage: "Перед внешней публикацией проверять согласование выбранных фотографий и разрешения участников.",
    language: "multi",
    updatedAt: "2026-07-29",
    tags: ["фото", "sps", "первая симуляция", "врачи", "google drive"],
  },
  {
    id: "construction-photos",
    title: "Фотографии строительства",
    category: "photo",
    fileType: "folder",
    url: "#replace-with-real-file-url",
    status: "needs-review",
    usage: "Проверить актуальность и разрешение на публикацию.",
    language: "multi",
    updatedAt: "2026-07-15",
    tags: ["фото", "строительство", "объект"],
    placeholder: true,
  },
  {
    id: "sps-video",
    title: "Видео о SPS",
    category: "video",
    fileType: "folder",
    url: "#replace-with-real-file-url",
    status: "current",
    usage: "Добавить ссылку на согласованную папку.",
    language: "multi",
    updatedAt: "2026-07-15",
    tags: ["видео", "sps", "симуляция"],
    placeholder: true,
  },
  {
    id: "publication-templates",
    title: "Шаблоны публикаций",
    category: "template",
    fileType: "folder",
    url: "#replace-with-real-file-url",
    status: "needs-review",
    usage: "Использовать только актуальные шаблоны после проверки бренд-командой.",
    language: "multi",
    updatedAt: "2026-07-15",
    tags: ["шаблоны", "социальные сети", "публикации"],
    placeholder: true,
  },
];
